import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Checkbox } from "../components/ui/checkbox";
import { toast } from "sonner";

export default function RegisterPage() {
  const { register, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isMinor, setIsMinor] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, password, name, isMinor);
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#151613] text-[#f1e0c5] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="font-display text-2xl flex items-center justify-center gap-2.5 mb-10">
          <img src="/logo192.png" alt="Call to Arms" className="w-8 h-8 rounded-md" data-testid="brand-logo-icon" />
          Call to Arms<span className="text-[#D90429]">.</span>
        </Link>
        <div className="panel-wood rounded-lg p-8">
          <h1 className="font-display text-3xl mb-6">Create your account</h1>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="name" className="text-xs uppercase tracking-wider text-[#f1e0c5]/60">Name</Label>
              <Input data-testid="register-name-input" id="name" value={name} onChange={(e) => setName(e.target.value)} required className="mt-1 bg-black/30 border-white/10" />
            </div>
            <div>
              <Label htmlFor="email" className="text-xs uppercase tracking-wider text-[#f1e0c5]/60">Email</Label>
              <Input data-testid="register-email-input" id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1 bg-black/30 border-white/10" />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs uppercase tracking-wider text-[#f1e0c5]/60">Password</Label>
              <Input data-testid="register-password-input" id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="mt-1 bg-black/30 border-white/10" />
            </div>
            <label className="flex items-start gap-2.5 pt-1 cursor-pointer">
              <Checkbox data-testid="register-is-minor-checkbox" checked={isMinor} onCheckedChange={(v) => setIsMinor(!!v)} className="mt-0.5" />
              <span className="text-xs text-[#f1e0c5]/60 leading-relaxed">I am under 18 — show me extra content filters on Knights Fee, our social hub</span>
            </label>
            <Button data-testid="register-submit-button" type="submit" disabled={loading} className="w-full rounded-full bg-[#D90429] hover:bg-[#b8031f] uppercase tracking-widest text-sm">
              Create Account
            </Button>
          </form>
          <p className="text-sm text-center mt-4 text-[#f1e0c5]/60">
            Already have an account?{" "}
            <Link to="/login" data-testid="register-login-link" className="text-[#D4AF37] hover:underline">
              Log in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
